import axios from 'axios'
import Vue from 'vue';
import {$http} from '@/utils/https'

function save() {
    const parsed = JSON.stringify(state.basket);

    localStorage.setItem('products', parsed);
}

import {
    ADD_BASKET,
    CHANGE_POPUP_REGISTER,
    FAST_ORDER,
    SET_CURRENT_ORDER,
    SET_HISTORY_ORDERS,
    SET_USER_INFO,
    THANKS_ORDER,
    INCREMENT_BASKET_LIST_COUNT,
    DECREMENT_BASKET_LIST_COUNT,
    REMOVE_ITEM_FROM_BASKET,
    RESET_BASKET,
    NOVA_POSHTA_SET_TOWNS,
    NOVA_POSHTA_SET_DEPARTMENS,
    CHANGE_ADDRESS,
    SET_ORDERS_METHODS,
    CHANGE_SUCCESS_BUY, SET_ORDER_STATUS
} from '../mutation-types';


import {
    CURRENT_ORDER,
    FAST_BUY, HISTORY_ORDERS,
    UPDATE_DATA,
    NOVA_POSHTA_GET_TOWNS,
    NOVA_POSHTA_GET_DEPARTMENS,
    ORDERS_METHODS,
    CREATE_ORDER,
    ORDER_STATUS
} from '../action-types';
import login from "@/components/popups/login";


const state = {
    successBuy: '',
    ordersMethods: '',
    address: {
        town: 'Киев',
    },
    departments: [],
    towns: [],
    changeShowFastOrder: false,
    changeShowThanksOrder: false,
    historyOrders: '',
    currentOrder: '',
    basket: localStorage.getItem('products') ? JSON.parse(localStorage.getItem('products')) : [],
    orderStatus: ''

};
const actions = {
    [ORDER_STATUS]: async ({commit},) => {
        try {
            // commit(SET_LOADING_REGISTRATION, true);

            const result = await $http.get(`v1/orders/get/current`);

            commit(SET_ORDER_STATUS, result.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_LOADING_REGISTRATION, false);
        }
    },
    [CREATE_ORDER]: async ({commit}, payload) => {
        // commit(CHANGE_LOADING, true);
        try {
            const response = await $http.post(`v1/orders/response`, payload);
            commit(CHANGE_SUCCESS_BUY, true);
            return response.data?.data
        } catch (e) {
            throw e;
        } finally {
            // commit(CHANGE_LOADING, false);
        }
    },
    [ORDERS_METHODS]: async ({commit}, payload) => {
        try {
            // commit(SET_LOADING_REGISTRATION, true);

            const result = await $http.get(`v1/orders/methods`, payload);

            commit(SET_ORDERS_METHODS, result.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_LOADING_REGISTRATION, false);
        }
    },
    [NOVA_POSHTA_GET_DEPARTMENS]: async ({commit}, payload) => {
        // commit(NOVA_POSHTA_GET_DEPARTMENS_LOADING, true);
        try {
            const response = await axios({
                method: 'POST',
                url: "https://api.novaposhta.ua/v2.0/json/",
                data: payload
            })
            commit(NOVA_POSHTA_SET_DEPARTMENS, response.data?.data)
        } catch (e) {
            throw e;
        } finally {
            // commit(NOVA_POSHTA_GET_DEPARTMENS_LOADING, false);
        }
    },
    [NOVA_POSHTA_GET_TOWNS]: async ({commit}, payload) => {
        // commit(NOVA_POSHTA_GET_TOWNS_LOADING, true);
        try {
            const response = await axios({
                method: 'POST',
                url: "https://api.novaposhta.ua/v2.0/json/",
                data: payload
            })
            commit(NOVA_POSHTA_SET_TOWNS, response.data?.data)
            commit(NOVA_POSHTA_SET_DEPARTMENS, [])
        } catch (e) {
            throw e;
        } finally {
            // commit(NOVA_POSHTA_GET_TOWNS_LOADING, false);
        }
    },
    [CURRENT_ORDER]: async ({commit}, payload) => {
        try {
            const result = await $http.post(`v1/orders/make`, payload);
            commit(SET_CURRENT_ORDER, result.data);
            if(payload.payment_method_id === 4){
            }
            else {
                const tempDiv = document.createElement('div');

                tempDiv.innerHTML = result.data.button;

                const form = tempDiv.querySelector('#liqpay-form');

                form.style.display = 'none';

                document.body.appendChild(form);

                form.submit();
            }
        } catch (e) {
            throw e;
        } finally {
        }
    },
    [FAST_BUY]: async ({commit}, payload) => {
        try {
            // commit(SET_LOADING_REGISTRATION, true);

            const result = await $http.post(`v1/orders/make`, payload);

            commit(SET_USER_INFO, result.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_LOADING_REGISTRATION, false);
        }
    },
    [HISTORY_ORDERS]: async ({commit},) => {
        try {
            // commit(SET_LOADING_REGISTRATION, true);

            const result = await $http.get(`v1/orders/get/history`);

            commit(SET_HISTORY_ORDERS, result.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_LOADING_REGISTRATION, false);
        }
    },

};

const getters = {
    ordersMethods: state => state.ordersMethods,
    departments: state => state.departments,
    towns: state => state.towns,
    changeShowFastOrder: state => state.changeShowFastOrder,
    changeShowThanksOrder: state => state.changeShowThanksOrder,
    historyOrders: state => state.historyOrders,
    getCurrentOrder: state => state.basket,
    currentOrder: state => state.currentOrder,
    address: state => state.address,
    successBuy: state => state.successBuy,
    orderStatus: state => state.orderStatus
};
const mutations = {
    [CHANGE_SUCCESS_BUY](state, val) {
        state.successBuy = val;
    },
    [CHANGE_ADDRESS](state, data) {
        console.log(data);
        Object.assign(state.address, data)
    },
    [NOVA_POSHTA_SET_DEPARTMENS](state, data) {
        state.departments = data
    },
    [NOVA_POSHTA_SET_TOWNS](state, data) {
        state.towns = data
    },
    [FAST_ORDER](state, status) {
        state.changeShowFastOrder = status
    },
    [THANKS_ORDER](state, status) {
        state.changeShowThanksOrder = status
    },
    [SET_ORDER_STATUS](state, data) {
        state.orderStatus = data
    },
    [SET_HISTORY_ORDERS](state, data) {
        state.historyOrders = data
    },
    [SET_ORDERS_METHODS](state, data) {
        state.ordersMethods = data
    },
    [SET_CURRENT_ORDER](state, data) {
        state.currentOrder = data
    },
    [ADD_BASKET](state, obj) {
        if (state.basket.length === 0) {
            state.basket.push(obj)
            save()
        }
        const list = state.basket.filter(e => e.id === obj.id)
        if (list.length) {
            const item = state.basket.find(e => e.id === obj.id);
            if (item) {
                const index = state.basket.findIndex(e => e.id === obj.id);
                obj.count = state.basket[index].count + 1
                obj.sum = obj.count * obj.price
                Vue.set(state.basket, index, obj)
            } else {
                obj.count = 1
                obj.sum = obj.count * obj.price
                state.basket.push(obj);
            }
        } else {
            obj.count = 1
            obj.sum = obj.count * obj.price
            state.basket.push(obj);
        }
        save()


    },
    [INCREMENT_BASKET_LIST_COUNT](state, obj) {
        obj.count = obj.count + 1;
        obj.sum = obj.count * obj.price
        Vue.set(state.basket, obj.index);
        save();
    },
    [DECREMENT_BASKET_LIST_COUNT](state, obj) {
        if (obj.count !== 1) {
            obj.count = obj.count - 1;
            obj.sum -= obj.price
        }

        Vue.set(state.basket, obj.index);
        save();
    },
    [REMOVE_ITEM_FROM_BASKET](state, obj) {
        const index = state.basket.findIndex(e => e.id === obj.id)

        state.basket.splice(index, 1);
        save();
    },
    [RESET_BASKET](state) {
        localStorage.removeItem('products');
        state.basket = [];
    },


}
export default {
    state,
    getters,
    actions,
    mutations,
};
